/**
 * IAMGrant
 */
export enum IamGrant {
    ALLOW = 'allow',
    DENY = 'deny',
    INHERIT = 'inherit'
}
